import { __assign, __rest } from "tslib";
import React from 'react';
import { Flex } from '@marvelapp/ui';
function PinCenter(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Flex, __assign({ alignItems: "center", flexDirection: "column", height: "100%", justifyContent: "center" }, props), children));
}
export default PinCenter;
